export default "__VITE_ASSET__BzimvuRj__"